import { http, helper } from '@ymt/gfw-axios'
import config from '@/config'

const gfwInitVersion = parseInt(localStorage.getItem('gfw_init_version')) // 客户端最后一次更新版本
const lastChangeVersion = 2 // 代码最后一次更新时间
let cleanInitStatus = true
if (gfwInitVersion === lastChangeVersion) {
  cleanInitStatus = false
}
if (cleanInitStatus) {
  localStorage.setItem('gfw_init_version', lastChangeVersion)
  helper.clearSid()
  helper.clearUUID()
}
http.setEnv({
  baseUrl: config.baseUrl
})
export { http, helper }
